import { ISite } from '@metservicedev/platforms-services-interface/src/services/movSites/MovSitesV2Model';
import { Expression } from 'mapbox-gl';

export const sourceId = 'mov://sites';

export const renderLayer = {
    id: sourceId,
    type: 'circle' as const,
    source: sourceId,
    interactive: true,
    paint: {
        'circle-radius': ['case', ['boolean', ['feature-state', 'hover'], false], 12, 8] as Expression,
        'circle-color': ['case', ['boolean', ['feature-state', 'isSelected'], false], '#423e7f', '#857dff'] as Expression,
    },
};

export const hoverLayer = {
    id: sourceId + '-hover',
    type: 'circle' as const,
    promoteId: 'movSiteId',
    source: sourceId,
    interactive: true,
    paint: {
        'circle-radius': 12,
        'circle-color': 'rgba(0, 0, 0, 0)',
    },
};

export const generateSource = (sites: ISite[]) => {
    return {
        type: 'FeatureCollection' as const,
        features: sites.map((site) => {
            return {
                type: 'Feature' as const,
                id: site.movSiteId,
                promoteId: 'id',
                properties: {
                    movSiteId: site.movSiteId,
                },
                geometry: {
                    type: 'Point' as const,
                    coordinates: [site.coordinates.lon, site.coordinates.lat],
                },
            };
        }),
    };
};
